import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyContentAndDesktopImageProps {
  content: Document;
  desktopImage: Asset;
  contentLocation: string;
  ctaText?: string;
  ctaLink?: string;
}

const DesktopWrapper = styled.div`
  @media(min-width: 1024px){
    height: 600px;
    max-height: auto;
  } @media(min-width: 1400px){
    height: 700px;
    max-height: auto;
  }
`;

const Desktop = styled.div`
  background-color: #ccc;
  padding-top:1.5rem;
  border-radius: 1rem;
  box-shadow:5px 5px 20px -2px rgba(0,0,0,0.5);

  @media(min-width: 1024px){

    width: 60vw;
    position: absolute;
    max-width: 1000px;
  }
`;

export const CaseStudyContentAndDesktopImage: React.FC<CaseStudyContentAndDesktopImageProps> = ({
  content,
  desktopImage,
  contentLocation,
  ctaText,
  ctaLink,
}) => {

  return (
    <div className="w-screen pb-20 overflow-hidden cs-block-natural lg:pb-32 ">
      <div className={`w-full max-w-6xl px-8 lg:flex lg:mx-auto lg:gap-5 ${contentLocation === 'Right' ? 'flex-row-reverse' : 'flex-row'}`}>
        <div className="mb-10 lg:mb-20 lg:w-1/2 lg:pt-8">
          <RichText content={content} />
        </div>
        <div className="relative lg:w-1/2">
          <DesktopWrapper className="relative">
            <Desktop className={`mr-auto`} style={{
              right: contentLocation === 'Right' ? '5vw' : 'auto',
              left: contentLocation === 'Left' ? '5vw' : 'auto',
            }}
            >
              <img src={desktopImage.url} alt={desktopImage.name} className={'object-cover w-full h-full'} />
            </Desktop>
          </DesktopWrapper>
        </div>
      </div>

      {ctaText && ctaLink && (
        <div className="w-full max-w-6xl px-8 pt-10 mx-auto">
          <a className="relative inline-block uppercase hover:underline" href={ctaLink}>{ctaText} <span className="absolute w-screen ml-4 border-b-2 pointer-events-none border-neon-green top-3" /></a>
        </div>
      )}
    </div>
  );
};
